import React from "react";
import Slider from "../../components/Home/Slider";
import HomeCategory from "../../components/Home/HomeCategory";
import CardProductContainer from "../../components/Products/CardProductContainer";
import DiscountCard from "../../components/Home/DiscountCard";
import BrandFeatured from "../../components/Brand/BrandFeatured";
import UseViewHomeProducts from "../../CustomHooks/Products/UseViewHomeProducts";
import NavBar from "../../components/Layout/NavBar";
import Footer from "../../components/Layout/Footer";
import UseViewSearchProducts from "../../CustomHooks/Products/UseViewSearchProducts";

const Home = () => {
  const [fashionproducts, toysroducts] = UseViewHomeProducts();
  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()

  return (
    <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <div className="mb-5">
        <Slider />
      </div>
      <HomeCategory />
      <div className="gray-bg py-5">
        {fashionproducts.length >= 1 ? (<CardProductContainer title="Fashion" btntitle="See More" pathlink={`/product/category/657028bbe68d4f75f5b372a5`} products={fashionproducts} />) : null}
      </div>
      <DiscountCard />
      <div className="py-5">
        {toysroducts.length >= 1 ? (<CardProductContainer title="Toys" btntitle="See More" pathlink={`/product/category/65b4f7e99e0d90716a2f0193`} products={toysroducts} />) : null}
      </div>
      <div className="gray-bg py-5">
        <BrandFeatured title="All Brands" btntitle="See More" />
      </div>
      <Footer />
    </>
  );
};

export default Home;
